import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Email_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="email_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Email Overview</h2>
              <p>
                The Nexoid framework includes a system for sending emails. By
                default this uses the Nexoid SMTP servers, however, this can be
                changed in the settings section of the application. User's and
                system accounts require the send email permission to send emails
                from the Nexoid framework.
              </p>
              <p>Emails are HTML email bodies by default.</p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Email_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Email_overview.js